export default __webpack_public_path__ + "static/media/store.7f5499aa.png";